export const DEFAULT_PER_PAGE_LIMIT = 10;

export const DEFAULT_ROWS_PER_PAGE_OPTIONS = [5, DEFAULT_PER_PAGE_LIMIT, 25, 50, 100];
